/**
 * Product Swiper Gallery
 * Initializes Swiper for product gallery with thumbs sync
 */

document.addEventListener('DOMContentLoaded', function () {
  initProductSwiperGalleries();
});

function initProductSwiperGalleries() {
  const galleries = document.querySelectorAll('.product-swiper-gallery');

  galleries.forEach((gallery) => {
    const sectionId = gallery.dataset.sectionId;
    const mainEl = gallery.querySelector('.product-swiper-main');
    const thumbsEl = gallery.querySelector('.product-swiper-thumbs');

    if (!mainEl) return;

    let thumbsSwiper = null;

    // Initialize thumbs swiper first
    if (thumbsEl) {
      thumbsSwiper = new Swiper(thumbsEl, {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          750: {
            slidesPerView: 4,
          },
          990: {
            slidesPerView: 4,
          },
        },
      });
    }

    // Initialize main swiper
    const mainSwiper = new Swiper(mainEl, {
      spaceBetween: 10,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: mainEl.querySelector('.swiper-button-next'),
        prevEl: mainEl.querySelector('.swiper-button-prev'),
      },
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
      grabCursor: true,
      on: {
        slideChange: function () {
          // Update is-active class for compatibility with existing code
          const activeSlide = this.slides[this.activeIndex];
          if (activeSlide) {
            const mediaId = activeSlide.dataset.mediaId;
            updateActiveState(gallery, mediaId);
          }
        },
      },
    });

    // Store swiper instances on element for external access
    gallery.mainSwiper = mainSwiper;
    gallery.thumbsSwiper = thumbsSwiper;

    // Listen for variant changes to slide the gallery to the new variant's image.
    //
    // NOTE (bug fix): the previous version gated this behind
    // `if (window.Shopify && window.Shopify.PaymentButton)` (usually undefined, so the
    // listener was never attached) and listened for a DOM `variant:change` event that
    // this theme never dispatches. Dawn's product-info.js instead PUBLISHES the
    // pub/sub event PUB_SUB_EVENTS.variantChange ('variant-change') with the payload
    // shape { data: { sectionId, html, variant } }. Subscribing to that is what makes
    // the image switch live (without a page refresh).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (eventData) => {
        const variant = eventData && eventData.data && eventData.data.variant;
        const changedSectionId = eventData && eventData.data && eventData.data.sectionId;
        const variantMediaId = variant && variant.featured_media && variant.featured_media.id;
        if (!variantMediaId) return;
        // Only react to the variant change belonging to this gallery's own section.
        if (changedSectionId != null && String(changedSectionId) !== String(sectionId)) return;
        goToMediaId(gallery, `${sectionId}-${variantMediaId}`);
      });
    }
  });
}

function updateActiveState(gallery, mediaId) {
  // Update active class on slides
  gallery.querySelectorAll('[data-media-id]').forEach((el) => {
    el.classList.toggle('is-active', el.dataset.mediaId === mediaId);
  });
}

function goToMediaId(gallery, mediaId) {
  if (!gallery.mainSwiper) return;

  const slides = gallery.mainSwiper.slides;
  for (let i = 0; i < slides.length; i++) {
    if (slides[i].dataset.mediaId === mediaId) {
      gallery.mainSwiper.slideTo(i);
      break;
    }
  }
}

// Export for external use
window.ProductSwiperGallery = {
  init: initProductSwiperGalleries,
  goToMediaId: goToMediaId,
};
